import { createFileRoute } from "@tanstack/react-router";
import { AgentsWorkbenchLayout } from "@/components/agents/agents-workbench";
import { useAgents, useWorkspaceRoot } from "@/lib/api";
import { redirectBareAgentToSettings } from "@/lib/agent-chat-routes";

export const Route = createFileRoute("/$owner/agents/$agentId")({
	beforeLoad: ({ params, location }) => {
		const base = `/${params.owner}/agents/${params.agentId}`;
		if (location.pathname === base || location.pathname === `${base}/`) {
			redirectBareAgentToSettings(params.owner, params.agentId);
		}
	},
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
		void queryClient.prefetchQuery(useAgents.queryOptions(params.owner));
	},
	component: AgentLayoutRoute,
});

function AgentLayoutRoute() {
	const { owner, agentId } = Route.useParams();
	return <AgentsWorkbenchLayout owner={owner} agentId={agentId} />;
}
